import { render, staticRenderFns } from "./ProjectAttachmentModal.vue?vue&type=template&id=81522d64"
import script from "./ProjectAttachmentModal.vue?vue&type=script&lang=js"
export * from "./ProjectAttachmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports